function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { padding } from '@bydesign-ui/utils';
export function toPercent(v) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 255;
  v = Math.min(n, Math.max(0, v));

  if (Math.abs(v - n) < 0.000001) {
    return 1;
  }

  return v / n;
}

function toHex(n) {
  return padding(Math.round(n).toString(16), 2);
}

function fromHex(str) {
  return parseInt(str, 16);
}

export function RGB2HEX(rgb) {
  var allowShort = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var hex = [toHex(rgb.r), toHex(rgb.g), toHex(rgb.b)];

  if (allowShort && hex.every(function (item) {
    return item.charAt(0) === item.charAt(1);
  })) {
    hex = hex.map(function (item) {
      return item.charAt(0);
    });
  }

  return '#' + hex.join('').toUpperCase();
}

function HEX2RGBA(hex) {
  if (hex.length === 3) {
    hex = hex + 'f';
  }

  if (hex.length === 4) {
    hex = hex.split('').map(function (item) {
      return item + item;
    }).join('');
  }

  if (hex.length === 6) {
    hex = hex + 'ff';
  }

  if (!/^[0-9a-f]{8}/.test(hex)) {
    return null;
  }

  return {
    r: fromHex(hex.slice(0, 2)),
    g: fromHex(hex.slice(2, 4)),
    b: fromHex(hex.slice(4, 6)),
    a: toPercent(fromHex(hex.slice(6))) * 100
  };
}

export function string2RGB(str) {
  str = str.trim().toLowerCase();

  if (str.charAt(0) === '#') {
    return HEX2RGBA(str.slice(1));
  }

  if (/^(hsla?|rgba?)\s*\((.+)\)\s*$/.test(str)) {
    var hasAlpha = RegExp.$1.length > 3;
    var type = hasAlpha ? RegExp.$1.slice(0, -1) : RegExp.$1;
    var content = RegExp.$2.trim().split(/,\s*/g).map(function (item) {
      return parseFloat(item.trim());
    });
    var a = hasAlpha && content[3] != null && isFinite(content[3]) ? content[3] * 100 : 100;

    if (type === 'hsl') {
      return _objectSpread(_objectSpread({}, HSL2RGB({
        h: content[0] || 0,
        s: content[1] || 0,
        l: content[2] || 0
      })), {}, {
        a: a
      });
    }

    return {
      r: content[0] || 0,
      g: content[1] || 0,
      b: content[2] || 0,
      a: a
    };
  }

  return null;
}
export function RGBA2HEX(rgba) {
  var allowShort = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var hex = [toHex(rgba.r), toHex(rgba.g), toHex(rgba.b), toHex(rgba.a / 100 * 255)];

  if (allowShort && hex.every(function (item) {
    return item.charAt(0) === item.charAt(1);
  })) {
    hex = hex.map(function (item) {
      return item.charAt(0);
    });
  }

  return '#' + hex.join('').toUpperCase();
}

function hue2RGB(p, q, t) {
  if (t < 0) {
    t += 1;
  }

  if (t > 1) {
    t -= 1;
  }

  if (t < 1 / 6) {
    return p + (q - p) * 6 * t;
  }

  if (t < 1 / 2) {
    return q;
  }

  if (t < 2 / 3) {
    return p + (q - p) * (2 / 3 - t) * 6;
  }

  return p;
}

export function RGB2HSL(rgb) {
  var r = toPercent(rgb.r);
  var g = toPercent(rgb.g);
  var b = toPercent(rgb.b);
  var max = Math.max(r, g, b);
  var min = Math.min(r, g, b);
  var h = 0;
  var s = 0;
  var l = (max + min) / 2;

  if (max === min) {
    h = 0;
    s = 0;
  } else {
    var d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;

      case g:
        h = (b - r) / d + 2;
        break;

      case b:
        h = (r - g) / d + 4;
        break;
    }

    h /= 6;
  }

  return {
    h: h * 360,
    s: s * 100,
    l: l * 100
  };
}
export function HSL2RGB(hsl) {
  var h = toPercent(hsl.h, 360);
  var s = toPercent(hsl.s, 100);
  var l = toPercent(hsl.l, 100);

  if (s === 0) {
    return {
      r: l * 255,
      g: l * 255,
      b: l * 255
    };
  }

  var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
  var p = 2 * l - q;
  var r = hue2RGB(p, q, h + 1 / 3);
  var g = hue2RGB(p, q, h);
  var b = hue2RGB(p, q, h - 1 / 3);
  return {
    r: r * 255,
    g: g * 255,
    b: b * 255
  };
}